/**
 * @generated SignedSource<<614f2f9e0ed8fee52ac0a38ccc1502c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Notes_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"MeetingContent_viewer" | "MeetingPhaseContext_viewer">;
  readonly " $fragmentType": "Notes_viewer";
};
export type Notes_viewer$key = {
  readonly " $data"?: Notes_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Notes_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notes_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingPhaseContext_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d8ad8ec8380e12366d33e32512d5f951";

export default node;
